import { useEffect, useState } from 'react';
import { GraphOptionItemProps } from '../types'
import { FormControl } from '@mui/material'
import { NumericInput } from 'components/controls/numbericInput';

export const GraphOptionNumericItem = <T,>({
	option,
	options,
	setOptionValue
}: GraphOptionItemProps<T>) => {
  const [value, setValue] = useState<string>(
    options.find((opt) => opt.id === option.id)?.value ?? 
    (option.defaultValue !== undefined ? option.defaultValue.toString() : '')
  )
  useEffect(() => {
    setOptionValue(option.id, value)
  }, [option.id, value, setOptionValue])

  return (
    <FormControl sx={{ width: '5em' }}>
      <NumericInput
        state={value}
        setState={setValue}
        label={option.label}
        size="small"
        fullWidth
      />
    </FormControl>
  );
}
